// extracted by mini-css-extract-plugin
export default {"container":"News_container__U9YP1","head":"News_head__3wjui","logo":"News_logo__T1CEZ","title":"News_title__tFVpg","info":"News_info__LE0sN","pic":"News_pic__1iv5r"};